import React, { SFC, useState, useEffect } from 'react'
import { CircularProgress, makeStyles } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { Autocomplete } from 'mui-rff'
import { promiseError } from '../redux/actions/common'
import { usePromise } from '../utils/usePromise'
import { FormApi } from 'final-form'

const useStyles = makeStyles((theme) => ({
    input: {
        backgroundColor: '#f5f5f5',
        borderRadius: theme.shape.borderRadius,
        // overflow: 'hidden',
        border: '1px solid #ddd',
        '& .MuiFilledInput-root': {
            backgroundColor: '#f5f5f5',
            borderRadius: theme.shape.borderRadius,
            paddingBottom: '6px',
            paddingRight: '18px !important',
            // height: '40px',
            boxShadow: 'none',
            '&:before, &:after': {
                display: 'none',
            },
        },
        '& .MuiInputLabel-root': {
            // top: '-7px',
            fontSize: '0.9rem',
            color: '#9e9e9e',
        },
        '& .MuiChip-root': {
            fontSize: '0.7rem',
            height: '2em',
        }
        // '& .MuiSelect-icon': {
        //     top: 'calc(50% - 12px)',
        // },
    },
    // Additional styles for the TextField input
    textField: {
        // '& .MuiFilledInput-input': {
        //     padding: '12px 14px', // Adjust padding
        //     fontSize: '1rem', // Font size
        //     // Add more styles if needed
        // },
        // '& .MuiInputLabel-outlined': {
        //     color: '#9e9e9e', // Change label color
        // },
        // '& .MuiInput-underline:before': {
        //     borderBottom: '1px solid #ddd', // Underline color
        // },
    },
}));

export type Option = {
    id: any
    label: string | undefined
}
interface AsyncAutoCompleteFormItemProps {
    form: FormApi<any>
    label: string
    field: string
    dataFetcher: Function
    optionMapper(input: any): Option
    initialOptions: Option[]
}
const AsyncAutoCompleteFormItem: SFC<AsyncAutoCompleteFormItemProps> = ({
    form,
    label,
    field,
    dataFetcher,
    optionMapper,
    initialOptions,
}) => {
    const classes = useStyles()
    const dispatch = useDispatch()

    const [open, setOpen] = useState<boolean>(false)
    const [fieldToUse, setFieldToUse] = useState<string>('')
    const [initialOptionsToUse, setInitialOptionsToUse] = useState<Option[]>()

    const [fetchData, inProgress, data, error] = usePromise(dataFetcher)

    useEffect(() => {
        if (open && data === undefined) {
            fetchData()
        }
    }, [open, data, fetchData])

    useEffect(() => {
        if (data === undefined) {
            fetchData()
        } else {
            setFieldToUse(field)
        }
    }, [data, fetchData, field])

    useEffect(() => {
        if (error) {
            dispatch(promiseError(error))
        }
    }, [error, dispatch])

    useEffect(() => {
        if (data !== undefined && !initialOptionsToUse) {
            const optionsData = data.map(optionMapper)
            const initialOptionsWithLabels = initialOptions.filter((x) => x !== null).map((x) => ({
                id: x.id,
                label: optionsData.find((y: Option) => y.id === x.id)?.label,
            }))
            const filteredInitialOptions = initialOptionsWithLabels.filter(opt => opt.id !== -1)
            form.change(field, filteredInitialOptions)
            setInitialOptionsToUse(filteredInitialOptions)
            setFieldToUse(field)
        }
    }, [data, initialOptionsToUse, initialOptions, optionMapper, form, field])

    return (
        <>
            {fieldToUse ? (
                <Autocomplete
                    name={fieldToUse}
                    label={label}
                    multiple
                    getOptionSelected={(option: any, value: any) => option.id === value.id}
                    getOptionLabel={(option: any) => option.label ?? ''}
                    getOptionValue={(option: any) => option.id}
                    options={data ? data.map(optionMapper) : []}
                    loading={inProgress}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    textFieldProps={{
                        fullWidth: true,
                        variant: 'filled',
                        className: `${classes.input} ${classes.textField}`,
                    }}
                />
            ) : (
                <CircularProgress color="inherit" size={20} />
            )}
        </>
    )
}

export default AsyncAutoCompleteFormItem
